import { render, staticRenderFns } from "./LeavingReply.vue?vue&type=template&id=5aa07944&scoped=true"
import script from "./LeavingReply.vue?vue&type=script&lang=js"
export * from "./LeavingReply.vue?vue&type=script&lang=js"
import style0 from "./LeavingReply.vue?vue&type=style&index=0&id=5aa07944&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aa07944",
  null
  
)

export default component.exports